import React from 'react';

const Loader = ({
    loading = true,
    backgroundColor = "bg-dark bg-opacity-50"
}) => {
    if (!loading) return null;

    return (
        <div
            className={`position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center ${backgroundColor}`}
            style={{ zIndex: 9999 }}
        >
            <div className="spinner-border text-light" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );
};

export default Loader;